import React, { useEffect } from 'react';

import * as echarts from 'echarts';

import { useGetDistanceTraveledToSeeClinicianQuery } from 'store/api/pkd/endpoints/graphs';
import { GraphWrapper } from '../AgeGraph/styles';
import { PageLoader } from 'shared-components/Loaders';
import { getResizedChartWidth } from 'utils/charts';
import { BasicSkeleton } from 'components/SkeletonLoaders';
import { Box } from '@mui/system';

const mileColors = ['#919191', '#6FB9C3', '#E37A3F', '#8F80AC', '#3AA203'];
const DistanceTraveledToSeeClinician = ({ id, width, height }) => {
  const {
    data: distanceTraveled,
    isLoading,
    isFetching,
  } = useGetDistanceTraveledToSeeClinicianQuery();
  const axisData = distanceTraveled?.map(
    (distance) => distance.distanceTraveled
  );
  const distanceData = distanceTraveled?.map((distance, index) => ({
    value     : distance.percentage,
    itemStyle : {
      color : mileColors[index],
    },
  }));

  useEffect(() => {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom, null, {
      width,
      height,
    });
    var option;

    option = {
      title : {
        text : null,
      },
      tooltip : {
        trigger     : 'axis',
        axisPointer : {
          type : 'shadow',
        },
      },
      legend : {
        show : false,
      },
      axisPointer : {
        show : false,
      },
      grid : {
        width        : '100%',
        top          : 15,
        left         : 0,
        right        : 0,
        bottom       : -15,
        containLabel : true,
      },
      xAxis : {
        type        : 'value',
        boundaryGap : ['0', 0.31],
        show        : false,
      },
      yAxis : {
        type        : 'category',
        data        : axisData,
        boundaryGap : true,
        axisLabel   : {
          inside        : true,
          margin        : 0,
          verticalAlign : 'bottom',
          lineHeight    : 37,
          fontSize      : 14,
          color         : '#434343',
          fontFamily    : 'Montserrat',
        },
        axisTick : {
          show : false,
        },
        axisLine : {
          show : false,
        },
      },
      series : [
        {
          name     : 'distance',
          type     : 'bar',
          data     : distanceData,
          barWidth : 18,
          label    : {
            formatter  : ({ value }) => `${value}%`,
            show       : true,
            position   : 'right',
            color      : 'inherit',
            fontSize   : 14,
            fontFamily : 'Montserrat',
            fontWeight : '900',
          },
        },
      ],
    };

    option && myChart.setOption(option);
    const breakpointWidth = 899;
    window.addEventListener('resize', () => {
      const newWidth = getResizedChartWidth(width, breakpointWidth);
      myChart.resize({
        width : newWidth,
      });
    });
    const chartWidth = getResizedChartWidth(width, breakpointWidth);
    myChart.resize({
      width : chartWidth,
    });
    // eslint-disable-next-line
  }, [axisData, distanceData]);

  return (
    <>
      {(isLoading || isFetching) && (
        <Box
          display='flex' flexDirection='column' gap='5px'>
          <BasicSkeleton
            height='15px'
          />
          <BasicSkeleton
            height='15px' width='80%'
          />
          <BasicSkeleton
            height='15px' width='70%'
          />
          <BasicSkeleton
            height='15px' width='50%'
          />
          <BasicSkeleton
            height='15px' width='80%'
          />
        </Box>
      )}
      <GraphWrapper
        isVisible={!isLoading}>
        <div
          id={id}
        />
      </GraphWrapper>
    </>
  );
};

export default DistanceTraveledToSeeClinician;
